import { useEffect, useState } from "react";
import SearchIcon from "../../assets/svg/SearchIcon.svg";
import TuneIcon from "@mui/icons-material/Tune";
import AddIcon from "@mui/icons-material/Add";
import "./Staff.css";
import axios from "axios";
import profileStaff from "../../assets/svg/defultImage.svg";
import noDataFound from "../../assets/images/noDataFound.jpg";
import FillterByStaff from "../../components/FillterByStaff";
import { InfoItem } from "../../components/Cards/VanProfileCard";
import useDebounce from "../../hooks/useDebounce";
import dayjs from "dayjs";

import DeleteModalStaff from "../../components/DeleteModalStaff";
import { useSelector } from "react-redux";
import { newHost } from "../Categories/CategoryProfile";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Autocomplete, IconButton, InputAdornment, OutlinedInput, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import defaultImage from "../../assets/svg/defultImage.svg";
import cameraIcon from "../../assets/svg/CameraIcon.svg";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DeleteModal from "../../components/Modals/DeleteModal";

function Staff() {
  const { user } = useSelector((state) => state.auth);
  const TOKEN = "Bearer " + user?.token;
   const headers = {
      Authorization:
        TOKEN,
    };

  const [staffStatus, setStaffStatus] = useState({})
  const [licenseStatus, setLicenseStatus] = useState([])
  const [licenseTypes, setLicenseTypes] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [staffId, setStaffId] = useState(null)



  // Upload images
  const [imagePreview, setImagePreview] = useState(null)
  const [imageLicensePreview, setImageLicensePreview] = useState(null)
 

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setValue("profile_photo", file);
    };
    reader.readAsDataURL(file);
  };


// gender data
  const gender = ["male", "female"];


   // job titles
  const [jobTitles, setjobtitles] = useState([]);
  const [selectedjobTitleName, setSelectedJobTitleName] = useState([])

  const fetch_job_type = async () => {
    await axios
      .get(`${newHost}portal/job_titles`, {
        headers
      })
      .then((response) => {
        setjobtitles(response.data.data.job_titles);
      })
      .catch((error) => {
        console.log(error, "job");
      });
  };
  useEffect(() => {
    fetch_job_type();
  }, []);


   // Form
      const {
        register,
        handleSubmit,
        formState: { errors},
        setValue,
        control,
        reset
      } =useForm({
  shouldUnregister: true,   
  defaultValues: {
    profile_photo: null,
    license_photo: null,
    job_title_ids: [],
    first_name: "",
    last_name: "",
    username: "",
    birth_date: null,
    phone_number: "",
    joined_at: null,
    gender: "",
    email: "",
    password: "",
    password_confirmation: "",
    status: "",
    license_type_id: "",
    expired_date: null,
    renewal_date: null,
    license_status: ""
  }
});

 // Modal handling
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

   const handleClose = () => {
    reset({
      profile_photo: null,
      license_photo: null,
      first_name: "",
      last_name: "",
      job_title_ids: [],
      joined_at: null,
      phone_number: "",
      birth_date: null,
      gender: "",
      username: "",
      email: "",
      password: "",
      password_confirmation: "",
      license_status:"",
      license_types:"",
      license_number:"",
      status:""

    });
    setSelectedJobTitleName([])
    setShow(false);
    setImagePreview(null)
    setImageLicensePreview(null)
    setIsEdit(false)
  };
// Password handling
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };
 // Submit Staff

   const [dataToUpdate, setDataToUpdate] = useState(null);

  const onSubmit = async (data,e) => {
    console.log(data);
    const formData = new FormData();

if (data.profile_photo instanceof File) {
  formData.append("profile_photo", data.profile_photo);
} 



    if(isEdit){
      formData.append("_method", "PATCH");
    }
    
    data.job_title_ids?.forEach((job, index)=>
    formData.append(`job_title_ids[${index}]`, job)
    )
    formData.append("first_name", data.first_name);
    formData.append("last_name", data.last_name);
    formData.append("username", data.username);
    formData.append("gender", data.gender);
    formData.append("status", data.status);
    formData.append("phone_number", data.phone_number);
    formData.append("email", data.email);
    if(!isEdit){
    formData.append("password", data.password);
    formData.append("password_confirmation", data.password_confirmation);
    }
       if(selectedjobTitleName?.includes("Driver") ){
   formData.append("license_type_id", data.license_type_id);
    formData.append("license_number", data.license_number);
   
    formData.append("license_status", data.license_status);
   if (data.license_photo instanceof File) {
  formData.append("license_photo", data.license_photo);
}
 formData.append(
    "expired_date",
    data.expired_date ? dayjs(data.expired_date).format("YYYY-MM-DD") : ""
  );

  formData.append(
    "renewal_date",
    data.renewal_date ? dayjs(data.renewal_date).format("YYYY-MM-DD") : ""
  );
       }
   formData.append(
    "birth_date",
    data.birth_date ? dayjs(data.birth_date).format("YYYY-MM-DD") : ""
  );
  formData.append(
    "joined_at",
    data.joined_at ? dayjs(data.joined_at).format("YYYY-MM-DD") : ""
  );

 
  if(isEdit){
    
    try {
      const response = await axios.post(
        `${newHost}portal/stuffs/${staffId}`,
        formData,
        {
          headers
        },

      );

      console.log(response.data);
      toast.success(response.data.message);
      handleClose();
      getStaffData()
    } catch (error) {
      toast.error(error.response?.data?.message);
      console.log(error);
    }
  }else{
    try {
      const response = await axios.post(
        `${newHost}portal/stuffs`,
        formData,
        {
          headers
        },
      );
      console.log(response.data);
      toast.success(response.data.message);
      handleClose();
      getStaffData()
    } catch (error) {
      toast.error(error.response?.data?.message);
      console.log(error);
    }
  }
  };
  const [staffDetails, setStaffDetails]= useState({})
  const handleUpdateStaff =  (staff,e)=>{
        setStaffDetails(staff)
        console.log(staff);
        setIsEdit(true)
        setStaffId(staff.id)
        setShow(true)
       
        setValue(
  "job_title_ids",
  staff.job_titles.map(job => job.id)
);

        setValue("first_name", staff.first_name)
        setValue("last_name", staff.last_name) 
        setValue("birth_date",staff.birth_date? dayjs(staff.birth_date) : null)
        setValue("joined_at", staff.joined_at? dayjs(staff.joined_at) : null)
        
        setValue("username", staff.username) 
        setValue("phone_number", staff.phone_number) 
        setValue("email", staff.email) 
        setValue("status", staff.status) 
        setValue("gender", staff.gender) 
          if(staff.job_titles.some((job)=> job.title == "Driver")){
        setSelectedJobTitleName("Driver")
        setValue("expired_date",staff.driver_license?.expired_date? dayjs(staff.driver_license.expired_date) : null)
        setValue("renewal_date", staff.driver_license?.renewal_date? dayjs(staff.driver_license.renewal_date) : null)
        setValue("license_status", staff.driver_license?.status) 
        setValue("license_number", staff.driver_license?.license_number) 
        setValue("license_type_id", staff.driver_license?.license_type_id) 
        if(staff.driver_license?.license_photo_path){
          setImageLicensePreview(`${newImageUrl}${staff.driver_license?.license_photo_path}`)
        }
        }
        if(staff.profile_photo_path){
        setImagePreview(`${newImageUrl}${staff.profile_photo_path}`)
      } 
      } 
   
     // Staff Data
  const [staffData, setStaffData] = useState([]);
 
  const getStaffData = () => {
  

    axios
      .get(`${newHost}portal/stuffs`, { headers })
      .then((response) => {
        setStaffData(response.data.data.stuffs);
        console.log(response.data.data.stuffs);
      })
      .catch((error) => {
        console.log(error.data);
      });
  };

const getLicenseTypes = async ()=>{
  try {
    const response = await axios.get(`${newHost}license_types`,{
      headers
    })
         console.log(response);
         setLicenseTypes(response.data.data.license_types)
  } catch (error) {
    console.log(error);
    
  }
}

const getLicenseStatus = async ()=>{
  try {
    const response = await axios.get(`${newHost}license_statuses`,{
      headers
    })
         console.log(response);
         setLicenseStatus(response.data.data.license_statuses)
  } catch (error) {
    console.log(error);
    
  }
}
const getStaffStatus = async ()=>{
  try {
    const response = await axios.get(`${newHost}portal/status`,{
      headers
    })
         console.log(response);
         setStaffStatus(response.data.data.stuff_statuses)
  } catch (error) {
    console.log(error);
    
  }
}


    useEffect(() => {
      getStaffData();
      }, []);
      useEffect(() => {
      getStaffStatus()
      getLicenseTypes()
      getLicenseStatus()
      }, [])



 

  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // State for selected job titles
  const [joinDate, setjoinDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedJobTitles, setSelectedJobTitles] = useState([]);

  // Handle job title selection
  const handleJobTitleChange = (event) => {
    if (selectedJobTitles.includes(event)) {
      setSelectedJobTitles((prev) => prev.filter((title) => title !== event));
      return;
    }
    setSelectedJobTitles((prev) => [...prev, event]);
  };

  // Filter staff based on selected job titles
  const filteredStaff = staffData.filter(
    (staffMember) =>
      selectedJobTitles.length === 0 ||
      staffMember.job_titles.some((jobTitle) =>
        selectedJobTitles.includes(jobTitle.slug)
      )
  );

  //debounce search filtering
  const debouncedSearchValue = useDebounce(searchQuery, 1000);
  useEffect(() => {
  if ( staffDetails && isEdit) {
    reset({
      first_name: staffDetails.first_name || "",
      last_name: staffDetails.last_name || "",
      username: staffDetails.username || "",
      email: staffDetails.email || "",
      phone_number: staffDetails.phone_number || "",
      gender: staffDetails.gender || null,
      status: staffDetails.status || null,
      job_title_ids: staffDetails.job_titles.map(j => j.id),

      joined_at: staffDetails.joined_at
        ? dayjs(staffDetails.joined_at)
        : null,

      birth_date: staffDetails.birth_date
        ? dayjs(staffDetails.birth_date)
        : null,

      renewal_date: staffDetails.driver_license?.renewal_date
        ? dayjs(staffDetails.driver_license?.renewal_date)
        : null,

      expired_date: staffDetails.driver_license?.expired_date
        ? dayjs(staffDetails.driver_license?.expired_date)
        : null,

      license_type_id: staffDetails.driver_license?.license_type_id || null,
      license_number: staffDetails.driver_license?.license_number || null,
      license_status: staffDetails.driver_license?.status || null,
    });
  }
}, [isEdit, staffDetails, reset]);
const navigate = useNavigate()
const handleNavigateToStaffProfile = (staff)=>{
 console.log(staff);
 navigate(`/staff/${staff.id}`)
 
}


// delete staff
  const [showDelete, setShowDelete] = useState(false)

  const handleDeleteShow = (id)=>{
    setDataToUpdate(id)
    setShowDelete(true)
  }  
  const handleDeleteClose = ()=>{
    setShowDelete(false)
  }
  const deleteStaffMember = async (id) => {
    try {
      const response = await axios.delete(
        `${newHost}portal/stuffs/${dataToUpdate}`,
        {
          headers: {
            Authorization:
              TOKEN,
          },
        }
      );

      toast.success(response.data.message);
      handleDeleteClose()
       getStaffData()
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  return (
    <>
      <div className="staff-page m-4">
        <Modal show={show} onHide={handleClose} dialogClassName="custom-staff-modal-size">
      <Modal.Header className="">
        <Modal.Title className="">{isEdit? "Update Staff" : "Add New Staff"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="my-3">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="d-flex justify-content-center">
              <label htmlFor="profile_photo" className="">
                <div style={{ width: "100px", height: "100px", borderRadius: "50%", border: "dashed 1px #C6C6C6" }} className=" p-4 position-relative">

                  <div style={{ width: "", height: "" }} className="">
                    <img
                      className="w-100"

                      src={
                        imagePreview
                          ? imagePreview
                          :
                          defaultImage
                      }
                      alt="profile_photo"
                    />
                  </div>


                  <input onChange={FileChange} type="file" id="profile_photo" className="d-none " />
                  {imagePreview ? null : <img className="cameraIconUploading" src={cameraIcon} alt="" />}
                </div>
              </label>




            </div>


            <div className="row my-2">
              <div className="col-md-6">
                <label htmlFor="first_name">First Name</label>
                <TextField  {...register("first_name",
                   {required:"First name is required"}
                  )} 
                   className="w-100 m-0" type="text" size="small" id="first_name" placeholder="Enter First Name" error={!!errors.first_name} />
                  {errors?.first_name && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.first_name?.message}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label htmlFor="last_name">Last Name</label>
                <TextField {...register("last_name",
                {required:"Last name is required"}

                )} className="w-100 m-0" type="text" size="small" id="last_name" placeholder="Enter Last Name" error={!!errors.last_name} />
                  {errors?.last_name && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.last_name?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6 remove-date-space">
                <label htmlFor="joined_at">Join on</label>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}>
                  <DemoContainer

                    components={["DatePicker"]}

                  >
                    <Controller
                    rules={{required:"Join at is required"}}
                      name="joined_at"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                         className="m-0 w-100"
                          slotProps={{ textField: { size: 'small',} }}

                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}

                        />
                      )}
                      
                    />
                   
                  </DemoContainer>
                </LocalizationProvider>      
                   {errors?.joined_at && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.joined_at?.message}
                    </p>
                  )}
                      </div>
              <div className="col-md-6">
                <label htmlFor="phone_number">Mobile number</label>
                <TextField {...register("phone_number" ,
                  {required:"Phone Number is required"}
                  )} className="w-100 m-0" type="text" size="small" id="phone_number" placeholder="Enter Mobile number" error={!!errors.phone_number} />
                   {errors?.phone_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.phone_number?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6 remove-date-space">
                <label htmlFor="birth_date">Birth Date</label>
                <LocalizationProvider

                  dateAdapter={AdapterDayjs}>
                  <DemoContainer

                    components={["DatePicker"]}

                  >
                    <Controller
                    rules={{required:"Birth date is required"}}
                      name="birth_date"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                        className="m-0 w-100"
                          slotProps={{ textField: { size: 'small', } }}

                          {...field}
                          value={field.value}
                          onChange={(date) => field.onChange(date)}

                        />
                      )}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                   {errors?.birth_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.birth_date?.message}
                    </p>
                  )}
              </div>
              <div className=" col-md-6">
                <label htmlFor="gender">Gender</label>
                <Controller
                  name="gender"
                  control={control}
                   rules={{required:"Gender is required"}}
                      render={({ field }) => {
                      const options = gender.map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select Gender" className="m-0"
                             error={!!errors.gender}
                            />
                          )}
                        />
                      );
                    }}
           
                  />
             {errors?.gender && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.gender?.message}
                    </p>
                  )}
              </div>
            </div>
            <div className="row my-2">
              <div className="col-md-6">
                <label htmlFor="username">Username</label>
                <TextField {...register("username", 
                  {required:"Username is required"}
                  )} className="w-100 m-0" type="text" size="small" id="username" placeholder="Enter Username" error={!!errors.username} />
                  {errors?.username && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.username?.message}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label htmlFor="email">Email</label>
                <TextField  {...register("email",
                  {required: "Email is required"}
                  )} className="w-100 m-0" type="text" size="small" id="email" placeholder="Enter Email" error={!!errors.email} />
                  {errors?.email && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.email?.message}
                    </p>
                  )}
              </div>
            </div>
            {isEdit? null :
               <div className="row my-2">
              <div className="col-md-6">
                <label htmlFor="password">Password</label>
                <OutlinedInput
                  {...register("password", {required: !isEdit ? "Password is required" : false,} 
                  )}
                  size="small"
                  id="password"
                  className="w-100"
                  placeholder="Enter Password"
                  type={showPassword ? 'text' : 'password'}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={
                          showPassword ? 'hide the password' : 'display the password'
                        }
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"

                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  error={!!errors.password}
                />
                  {errors?.password && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.password?.message}
                    </p>
                  )}
              </div>
              <div className="col-md-6">
                <label htmlFor="password_confirmation">Confirm Password</label>
                <OutlinedInput
                  {...register("password_confirmation" ,  
                    {    required: !isEdit ? "Confirmation Password is required" : false,
    validate: (value, formValues) =>
      !isEdit && value !== formValues.password
        ? "Passwords do not match"
        : true,} 
                  )}
                  size="small"
                  id="password_confirmation"
                  placeholder="Confirm Password"
                  type={showPassword ? 'text' : 'password'}
                  className="w-100"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={
                          showPassword ? 'hide the password' : 'display the password'
                        }
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"

                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  error={!!errors.password_confirmation}
                />
                  {errors?.password_confirmation && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.password_confirmation?.message}
                    </p>
                  )}
              </div>
            </div>
            
            }
         
            <div className="row my-3">
              <div className="col-md-6">
                <label htmlFor="status">Status</label>
             <Controller
            rules={{required:"Status is required"}} 
              name="status"
              control={control}
              render={({ field }) => {
                const options = Object.entries(staffStatus).map(([key, value]) => ({
                  id: key,
                  label: value,
                }));

                return (
                  <Autocomplete
                    size="small"
                    options={options}
                    value={options.find(opt => opt.id == field.value) || null}

                    onChange={(e, item) => {
                      field.onChange(item ? item.id : null);
                    }}

                    renderOption={(props, option) => (
                      <li {...props} className="p-2">
                        {option.label}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="m-0"
                        placeholder="Select Status"
                        error={!!errors.status}
                      />
                    )}
                  />
                );
              }}
/>

            {errors?.status && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.status?.message}
                    </p>
                  )}
              </div>
              <div className=" col-md-6">
                <label htmlFor="job_title_id">Job Title</label>
            <Controller
  name="job_title_ids"
  control={control}
  rules={{ required: "Job title is required" }}
  defaultValue={[]}
  render={({ field }) => {
    const options = jobTitles.map(j => ({
      label: j.title,
      id: j.id,
    }));

    return (
      <Autocomplete
        multiple
        disableCloseOnSelect
        size="small"
        options={options}
        value={options.filter(opt =>
          field.value.includes(opt.id)
        )}
        onChange={(e, newValue) => {
          const ids = newValue.map(v => v.id);
          const titles = newValue.map(v => v.label);

          field.onChange(ids);
          setSelectedJobTitleName(titles);
        }}
        getOptionLabel={(option) => option.label}
     renderTags={(value, getTagProps) =>
       value.map((option, index) => 
        { const tagProps = getTagProps({ index }); return ( <span {...tagProps} key={option.id} className="d-flex align-items-center mx-1" style={{ padding: "2px 6px", borderRadius: "12px", backgroundColor: "#e0e0e0", fontSize: "0.8rem", display: "flex", alignItems: "center", gap: "6px", }} > <span>{option.label}</span> <span onClick={tagProps.onDelete} style={{ cursor: "pointer", fontSize: "12px", lineHeight: 1, color: "#555", }} > <Close sx={{ color: "red", fontSize: "16px" }} /> </span> </span> ); })}
     renderOption={(props, option, state) => ( <li {...props} className="custom-menu-item" style={{ padding: "10px 12px", display: "flex", alignItems: "center", gap: "10px", margin: "5px", backgroundColor: state.selected ? "rgba(193, 203, 213, 0.15)" : state.hovered ? "rgba(175, 175, 175, 0.06)" : "transparent", borderRadius: "6px", }} > <div className="label-size m-0">{option.label}</div> </li> )} ListboxProps={{ style: { maxHeight: 220, overflowY: "auto", padding: "6px", }, }}
        renderInput={(params) => (
          <TextField {...params} placeholder="Select Job title" />
        )}
      />
    );
  }}
/>

           
               {errors?.job_title_ids && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.job_title_ids?.message}
                    </p>
                  )}
              </div>
            </div>
            {selectedjobTitleName?.includes("Driver") ?
              <>
                <div className="my-2">
                  <div className="row my-2 align-items-center">
                    <div className="col-md-3">
                      <p className="label-size  main-text-color m-0">Driver License Info</p>
                    </div>
                    <div style={{ border: "1px solid #D8D8D8", height: 0 }} className="col-md-9"></div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-6">
                      <label htmlFor="license_number">License Number</label>
                      <TextField {...register("license_number",
                        {required:"License number is required"}
                        )} className="w-100 m-0" type="text" size="small" id="license_number" placeholder="Add license number" error={!!errors.license_number} />
                        {errors?.license_number && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_number?.message}
                    </p>
                  )}
                    </div>
                    <div className=" col-md-6">
                      <label htmlFor="license_type_id">License Type</label>
                      <Controller
                      rules={{required:"License Type"}}
                        name="license_type_id"
                        control={control}

                      render={({ field }) => {
                      const options = licenseTypes.map(option => ({
                        label: option.name,
                        id: option.id,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField className="m-0" {...params} placeholder="Select License"
                              error={!!errors?.license_type_id}

                            />
                          )}
                        />
                      );
                    }}
                        />
                          {errors?.license_type_id && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_type_id?.message}
                    </p>
                  )}

                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-6 remove-date-space">
                      <label htmlFor="renewal_date">Renewal date</label>
                      <LocalizationProvider

                        dateAdapter={AdapterDayjs}>
                        <DemoContainer


                                
                          components={["DatePicker"]}

                        >
                          <Controller
                          rules={{required:"Renewal Date is required"}}
                            name="renewal_date"
                            control={control}
                            render={({ field }) => (
                              <DatePicker
                              className="m-0 w-100"
                                slotProps={{ textField: { size: 'small', } }}

                                {...field}
                                value={field.value}
                                onChange={(date) => field.onChange(date)}

                              />
                            )}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                         {errors?.renewal_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.renewal_date?.message}
                    </p>
                  )}
                                    </div>
                    <div className="col-md-6 remove-date-space">
                      <label htmlFor="expired_date">Expiration date</label>
                      <LocalizationProvider

                        dateAdapter={AdapterDayjs}>
                        <DemoContainer



                          components={["DatePicker"]}

                        >
                          <Controller
                          rules={{required:"Expiration Date is required"}}
                            name="expired_date"
                            control={control}
                            render={({ field, }) => (
                              <DatePicker
                              className="m-0 w-100"
                                slotProps={{ textField: { size: 'small', } }}

                                {...field}
                                value={field.value}
                                onChange={(date) => field.onChange(date)}

                              />
                            )}
                          />
                        </DemoContainer>
                      </LocalizationProvider>      
                         {errors?.expired_date && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.expired_date?.message}
                    </p>
                  )}
                              </div>
                  </div>
                  <div className="row my-2">
                    <div className=" col-md-12">
                      <label htmlFor="license_status">License Status</label>
                      <Controller
                        rules={{required:"License status is required"}}
                        name="license_status"
                        control={control}

                       render={({ field }) => {
                      const options = licenseStatus.map(option => ({
                        label: option,
                        id: option,
                      }));

                      return (
                        <Autocomplete
                          size="small"
                          options={options}
                          value={options.find(opt => opt.id == field.value) || null}

                          onChange={(e, item) => {
                            field.onChange(item ? item.id : null);
                          }}

                          renderOption={(props, option) => (
                            <li {...props} className="p-2">
                              {option.label}
                            </li>
                          )}

                          renderInput={(params) => (
                            <TextField {...params} placeholder="Select License Status" className="m-0"
                             error={!!errors.license_status}
                            />
                          )}
                        />
                      );
                    }}
                         />
                     {errors?.license_status && (
                    <p style={{ fontSize: "13px" }} className="text-danger fw-semibold">
                      {errors?.license_status?.message}
                    </p>
                  )}
                    </div>
                  </div>
                  <div className="row my-2">
                    <div className="col-md-12">
                      <label className="label-size main-text-color w-100" htmlFor="license_photo">
                        License Image <span className="text-danger">*</span>
                        <div style={{ border: "dashed 1px #C6C6C6" }} className="p-4 d-flex justify-content-center">
                          <div style={{ width: "150px", height: "80px" }} className="text-center">
                            <img className={`${imageLicensePreview ? "w-100 h-100" : "w-50 h-50"}`} src={imageLicensePreview ? imageLicensePreview : cameraIcon} alt="" />
                            {imageLicensePreview ? null : <p className="main-text-color m-0">Add Image</p>}
                          </div>
                        </div>

<Controller
  name="license_photo"
  control={control}
  defaultValue={null}
  rules={{
    validate: (value) => {
      if (imageLicensePreview) return true;

      if (value instanceof File) return true;

      return "License image is required";
    },
  }}
  render={({ field }) => (
    <input
      type="file"
      id="license_photo"
      className="d-none"
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
          setImageLicensePreview(reader.result);
          field.onChange(file);
        };
        reader.readAsDataURL(file);
      }}
    />
  )}
/>





                      </label>
                        {errors?.license_photo && (
                    <p style={{ fontSize: "13px" }} className="text-danger my-1 fw-semibold text-center">
                      {errors?.license_photo?.message}
                    </p>
                  )}
                    </div>
                  </div>
                </div>
              </>
              : null}
                <div className="d-flex gap-3 justify-content-center align-items-center my-3 input-group-responsive">
              <button type="submit" className="btn btn-dark px-5">Save</button>
              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
            </div>

          </form>
        </div>

      </Modal.Body>
    </Modal>
    
        
         <DeleteModal
              showDelete={showDelete}
              handleDeleteClose={handleDeleteClose}
              textMessage={`Are you sure you want to delete this staff? Confirm to proceed or cancel to keep it.`}
              deleteFunction={deleteStaffMember}
            />
        <FillterByStaff
          handleJobTitleChange={handleJobTitleChange}
          selectedJobTitles={selectedJobTitles}
          setSelectedJobTitles={setSelectedJobTitles}
          open={open}
          toggleDrawer={toggleDrawer}
          filteredStaff={filteredStaff.length}
          joinDate={joinDate}
          setjoinDate={setjoinDate}
        />
        <div className="staff-hader">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">Staff</p>
          <div className="staff-header_edete">
            {staffData.length > 0 ? (
              <>
                <div className="searchAndFilter-wrapper">
                  <input
                    type="text"
                    className="searchAndFilter-input"
                    placeholder="Search for roles"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <img
                    src={SearchIcon} 
                    alt="search"
                    className="searchAndFilter-icon"
                  />
                </div>
                <div
                  onClick={toggleDrawer(true)}
                  className="staff-header_edete-icon mainBorder me-15"
                >
                  <TuneIcon />
                </div>
              </>
            ) : null}
            <div
              onClick={handleShow}
              className="staff-header_edete-icon mainBorder d-flex "
            >
              <AddIcon />
              <span className="ms-1 d-flex">Add Member</span>
            </div>
          </div>
        </div>
        {staffData.length > 0 ? (
          <>
            <div className="">
              <div className="row">
              {filteredStaff
                ?.filter((e) =>
                  e.name.toLowerCase().includes(debouncedSearchValue)
                )
                .filter((e) => {
                  if (!joinDate) return true;
                  if (!e.joined_at) return false;
                  return dayjs(e.joined_at).format("YYYY-MM-DD") === joinDate;
                })
                .map((response) => {
                  return (
                    <div className="col-12 col-lg-4 col-md-6">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNavigateToStaffProfile(response);
                        }}
                        key={response.id}
                        className="w-100 card rounded-3 p-3 my-2"
                      >
                        <div className="staff-cards-card_title">
                          <div className="staff-cards-card_jobT">
                            {response.primary_job_title.length > 0
                              ? response.primary_job_title[0].title
                              : "-"}
                          </div>
                          <div
                            className="staff-cards-card_rank"
                            style={{
                              display: "flex",
                              cursor: "pointer",
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleUpdateStaff(response);
                              }}
                              disableRipple
                            >
                              <EditOutlinedIcon />
                            </IconButton>

                            <IconButton
                              color="error"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteShow(response.id);
                              }}
                              disableRipple
                            >
                              <DeleteOutlineOutlinedIcon />
                            </IconButton>
                          </div>
                        </div>
                        <div className="staff-cards-card_staffInfo">
                          <div className="staff-cards-card_staffInfo_img">
                            {response.profile_photo_path ? (
                              <img
                                src={`${newImageUrl}${response.profile_photo_path}`}
                                alt=""
                              />
                            ) : (
                              <img src={profileStaff} alt="'" />
                            )}
                          </div>
                          <div className="staff-cards-card_staffInfo_name">
                            {response.first_name + " " + response.last_name}
                          </div>
                        </div>
                        <div className="staff-cards-card_staffDate">
                          {response.reference != null && (
                            <InfoItem
                              label="Reference Number"
                              value={response.reference || "Not Found"}
                            />
                          )}
                          <InfoItem
                            label="Joined on"
                            value={
                              dayjs(response.joined_at).format(
                                "MMM, D, YYYY",
                              ) || "Not Found"
                            }
                          />
                          <InfoItem
                            label="Mobile Number"
                            value={response.phone_number || "Not Found"}
                          />
                          <InfoItem
                            label="Birth date"
                            value={
                              dayjs(response.birth_date).format(
                                "MMM D, YYYY",
                              ) || "Not Found"
                            }
                          />
                          <InfoItem
                            label="Gender"
                            value={response.gender || "Not Found"}
                          />
                          <InfoItem
                            label="Username"
                            value={response.username || "Not Found"}
                          />
                          <InfoItem
                            label="Email"
                            value={response.email || "Not Found"}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                </div>
            </div>
          </>
        ) : (
          <div className="noStaff-cards mainBorder">
            <img
              className="noStaffImg"
              src={noDataFound}
              alt="No staff members"
            />
            <p className="noDataStaff-masege">
              No staff members have been added to this page yet. Click to add
              new staff members.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default Staff;
